import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';

import { OrdersService } from '../../../../core/services/orders/orders.service';
import { debounceTime, distinctUntilChanged, fromEvent, Subject } from 'rxjs';

@Component({
  selector: 'app-hea-filter',
  standalone: true,
  imports: [CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,],
  templateUrl: './hea-filter.component.html',
  styleUrl: './hea-filter.component.css'
})
export class HeaFilterComponent {
  @ViewChild('searchBox') searchBox!: ElementRef;
  @Output() emitCloseSearch = new EventEmitter<void>();
  searchText = '';
  searchSuggestions: any[] = [];
  isSearchTriggeredByEnter = false;
  searchTerms: Subject<string> = new Subject<string>();

  @ViewChild('headerFilter', { static: true }) headerFilter!: ElementRef;

  constructor(private elementRef: ElementRef, private orderService: OrdersService) { }

  // Detecta clic fuera del componente
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.headerFilter && this.headerFilter.nativeElement.contains(event.target)) {
      // Click dentro del headerFilter, no hacer nada
      return;
    }
    this.onClickOutside();
  }

  onClickOutside() {
    // Aquí tu lógica, por ejemplo:
    this.searchText = '';
    this.searchSuggestions = [];
  }



  ngAfterViewInit() {
    // Detectar cambios en el input con debounce y evitar duplicados
    this.searchTerms
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe(() => {
        if (!this.isSearchTriggeredByEnter) {
          if (this.searchText.trim() != '') {
            this.search_pro();
          } else {
            setTimeout(() => {
              this.onClickOutside();
            }, 1000); // Limpiar sugerencias después de 1 segundo si no hay texto
          }
        }
        this.isSearchTriggeredByEnter = false; // Resetear bandera después de debounce
      });

    // Detectar eventos de teclado para manejar Enter
    fromEvent<KeyboardEvent>(this.searchBox.nativeElement, 'keyup')
      .subscribe((event: KeyboardEvent) => {
        const term = (event.target as HTMLInputElement).value;
        this.searchTerms.next(term);
        if (event.key === 'Enter') {
          this.isSearchTriggeredByEnter = true; // Marcar como búsqueda por Enter
          this.search_pro(); // Ejecutar búsqueda inmediata
        }
      });
  }

  keyup(event: KeyboardEvent) {
    this.searchTerms.next((event.target as HTMLInputElement).value);
  }



  search_pro(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.orderService.searchPro(this.searchText).subscribe({
        next: (data) => {
          this.searchSuggestions = [data.data];
          resolve();
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  }

  objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }
/*
  private _showSearchInput = false;

  @Input()
  set showSearchInput(value: boolean) {
    this._showSearchInput = value;
    if (!value) {
      setTimeout(() => {
        const input = document.getElementById('hea-search-input');
        if (input) (input as HTMLInputElement).focus();
      }, 0);
    }
  }

  get showSearchInput() {
    return this._showSearchInput;
  }
 */
}
